import { jobTitleLabel } from '../strings/labels'

export const jobTitleField = {
  type: 'text',
  label: jobTitleLabel,
  name: 'employment__job_title'
}

export const workPhoneField = {
  type: 'text',
  label: 'Work phone',
  name: 'employment__phone'
}

export const workPhone2Field = {
  type: 'text',
  label: 'Work phone 2',
  name: 'employment__phone2'
}
